"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/slider/index.ts
var slider_exports = {};
__export(slider_exports, {
  default: () => Slider_default
});
module.exports = __toCommonJS(slider_exports);
var import_index2 = require("./index.css");

// src/slider/Slider.tsx
var import_classnames3 = __toESM(require("classnames"));
var import_react3 = require("react");

// src/button/index.ts
var import_index = require("./index.css");

// src/button/Button.tsx
var import_react2 = require("react");

// src/button/_BaseButton.tsx
var import_classnames2 = __toESM(require("classnames"));
var import_react = require("react");

// src/fontAwesomeV6Icon/FontAwesomeV6Icon.tsx
var import_classnames = __toESM(require("classnames"));
var import_jsx_runtime = require("react/jsx-runtime");
var FontAwesomeV6Icon = ({
  iconStyle,
  iconFamily,
  iconName,
  className,
  title,
  animationType,
  ...HTMLAttributes3
}) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
  "i",
  {
    "data-testid": "font-awesome-v6-icon",
    className: (0, import_classnames.default)(
      iconFamily && `fa-${iconFamily}`,
      iconStyle && `fa-${iconStyle}`,
      iconName && `fa-${iconName}`,
      // Default icon style is solid, but only when no iconFamily prop is provided
      !iconFamily && !iconStyle && "fa-solid",
      animationType && `fa-${animationType}`,
      className
    ),
    title,
    ...HTMLAttributes3
  }
);
var FontAwesomeV6Icon_default = FontAwesomeV6Icon;

// src/button/_baseButton.module.scss
var baseButton_module_default = {
  "heading-xxl": "_baseButton-module__heading-xxl___kwcRh",
  "heading-xl": "_baseButton-module__heading-xl___6zj6T",
  "heading-lg": "_baseButton-module__heading-lg___d7IqT",
  "heading-md": "_baseButton-module__heading-md___SmDLp",
  "heading-sm": "_baseButton-module__heading-sm___RUZyC",
  "heading-xs": "_baseButton-module__heading-xs___V91tJ",
  "body-one": "_baseButton-module__body-one___jiSyp",
  "body-two": "_baseButton-module__body-two___mLyhO",
  "body-three": "_baseButton-module__body-three___d5NIG",
  "body-four": "_baseButton-module__body-four___Kkh5r",
  "overline-one": "_baseButton-module__overline-one___v-7Xu",
  "overline-two": "_baseButton-module__overline-two___KG-wC",
  "overline-three": "_baseButton-module__overline-three___1RIPW",
  "strong": "_baseButton-module__strong___otOkq",
  "extra-strong": "_baseButton-module__extra-strong___dwGgk",
  "em": "_baseButton-module__em___cb8jk",
  "figcaption": "_baseButton-module__figcaption___7n9Wp",
  "button": "_baseButton-module__button___gGYwf",
  "buttonPendingWithHiddenText": "_baseButton-module__buttonPendingWithHiddenText___1W2Ul",
  "button-withForcedHover": "_baseButton-module__button-withForcedHover___tzWjJ",
  "button-primary": "_baseButton-module__button-primary___2ksGH",
  "button-purple": "_baseButton-module__button-purple___31oil",
  "button-black": "_baseButton-module__button-black___rgoFL",
  "button-white": "_baseButton-module__button-white___1kMMR",
  "button-destructive": "_baseButton-module__button-destructive___2OpdN",
  "button-secondary": "_baseButton-module__button-secondary___BpcuR",
  "button-gray": "_baseButton-module__button-gray___JxYvC",
  "button-tertiary": "_baseButton-module__button-tertiary___MMZKG",
  "button-l": "_baseButton-module__button-l___RV0rB",
  "button-iconOnly": "_baseButton-module__button-iconOnly___zWjVA",
  "button-m": "_baseButton-module__button-m___1eKjJ",
  "button-s": "_baseButton-module__button-s___WsV-p",
  "button-xs": "_baseButton-module__button-xs___VnYav"
};

// src/button/_BaseButton.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var checkButtonPropsForErrors = ({
  icon,
  useAsLink,
  onClick,
  href,
  download,
  text,
  isIconOnly,
  color,
  type
}) => {
  if (color === "gray" && type == "primary" || color === "gray" && type === "tertiary" && !isIconOnly) {
    throw new Error(
      "Expect type prop to be secondary or tertiary(with isIconOnly prop set to true) when color is gray"
    );
  }
  if (color === "purple" && type === "secondary") {
    console.warn(
      "Warning: Button - Secondary Purple color is now deprecated. Please use different color or type. Secondary purple combination will be removed very soon."
    );
  }
  if (useAsLink) {
    if (!href) {
      throw new Error("Expect href prop when useAsLink is true");
    }
    if (onClick) {
      throw new Error(
        "Expect onClick prop to be undefined when useAsLink is true"
      );
    }
  }
  if (!useAsLink) {
    if (!onClick) {
      throw new Error("Expect onClick prop when useAsLink is false");
    }
    if (href) {
      throw new Error(
        "Expect href prop to be undefined when useAsLink is false"
      );
    }
    if (download) {
      throw new Error(
        "Expect download prop to be undefined when useAsLink is false"
      );
    }
  }
  if (isIconOnly) {
    if (!icon) {
      throw new Error("Expect icon prop when isIconOnly is true");
    }
    if (text) {
      throw new Error(
        "Expect text prop to be undefined when isIconOnly is true"
      );
    }
  }
  if (!isIconOnly) {
    if (icon) {
      throw new Error(
        "Expect icon prop to be undefined when isIconOnly is false"
      );
    }
    if (!text) {
      throw new Error("Expect text prop when isIconOnly is false");
    }
  }
};
var spinnerIcon = {
  iconName: "spinner",
  iconStyle: "solid",
  animationType: "spin"
};
var BaseButton = ({
  className,
  id,
  disabled = false,
  isPending = false,
  ariaLabel,
  size = "m",
  type = "primary",
  color = "purple",
  buttonTagTypeAttribute = "button",
  /** Text button specific props */
  iconLeft,
  iconRight,
  text,
  /** IconOnly button specific props*/
  isIconOnly = false,
  icon,
  /** <a> specific props */
  useAsLink = false,
  href,
  target,
  download,
  title,
  /** <button> specific props */
  onClick,
  value,
  name,
  forceHover = false,
  ...rest
}) => {
  const ButtonTag = useAsLink ? "a" : "button";
  const tagSpecificProps = ButtonTag === "a" ? {
    href: disabled ? void 0 : href,
    target,
    /** Copied from old button component. Only need it for the older browsers,
     *  since modern browsers (~2020+ release year secures these vulnerabilities by default) */
    // Opening links in new tabs with 'target=_blank' is inherently insecure. Unfortunately, we depend
    // on this functionality in a couple of place. Fortunately, it is possible to partially mitigate some of
    // the insecurity of this functionality by using the `rel` tag to block some of the potential exploits.
    // Therefore, we do so here.
    rel: target === "_blank" ? "noopener noreferrer" : void 0,
    download,
    title
  } : { type: buttonTagTypeAttribute, onClick, value, name };
  (0, import_react.useMemo)(
    () => checkButtonPropsForErrors({
      type,
      icon,
      useAsLink,
      onClick,
      href,
      download,
      text,
      isIconOnly,
      color
    }),
    [type, icon, useAsLink, onClick, href, download, text, isIconOnly, color]
  );
  const showIcon = icon && !isPending;
  const showIconLeft = iconLeft && !isPending;
  const showIconRight = iconRight && !isPending || isPending && iconRight && iconLeft;
  const addPendingButtonWithHiddenTextClass = isPending && !icon && !iconLeft && !iconRight;
  const spinnerPosition = iconRight && !iconLeft ? "right" : "left";
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsxs)(
    ButtonTag,
    {
      className: (0, import_classnames2.default)(
        baseButton_module_default.button,
        baseButton_module_default[`button-${type}`],
        baseButton_module_default[`button-${color}`],
        baseButton_module_default[`button-${size}`],
        forceHover && baseButton_module_default["button-withForcedHover"],
        isIconOnly && baseButton_module_default["button-iconOnly"],
        addPendingButtonWithHiddenTextClass && baseButton_module_default.buttonPendingWithHiddenText,
        className
      ),
      id,
      disabled,
      ...rest,
      "aria-disabled": disabled || rest["aria-disabled"],
      "aria-label": ariaLabel || rest["aria-label"],
      ...tagSpecificProps,
      children: [
        isPending && spinnerPosition === "left" && /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(FontAwesomeV6Icon_default, { ...spinnerIcon }),
        showIconLeft && /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(FontAwesomeV6Icon_default, { ...iconLeft }),
        showIcon && /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(FontAwesomeV6Icon_default, { ...icon }),
        text && /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("span", { children: text }),
        showIconRight && /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(FontAwesomeV6Icon_default, { ...iconRight }),
        isPending && spinnerPosition === "right" && /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(FontAwesomeV6Icon_default, { ...spinnerIcon })
      ]
    }
  );
};
var BaseButton_default = (0, import_react.memo)(BaseButton);

// src/button/Button.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var Button = (props) => /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(BaseButton_default, { ...props });
var Button_default = (0, import_react2.memo)(Button);

// src/slider/slider.module.scss
var slider_module_default = {
  "sliderBlackTrackFillColor": "var(--background-neutral-primary-inverse)",
  "sliderBlackTrackEmptyColor": "var(--background-neutral-quinary)",
  "sliderBlackTrackDisabledColor": "var(--background-neutral-disabled)",
  "sliderBrandTrackFillColor": "var(--background-brand-teal-primary)",
  "sliderBrandTrackEmptyColor": "var(--background-neutral-quinary)",
  "sliderBrandTrackDisabledColor": "var(--background-neutral-disabled)",
  "sliderWhiteTrackFillColor": "var(--background-neutral-primary)",
  "sliderWhiteTrackEmptyColor": "var(--neutral-gray-60)",
  "sliderWhiteTrackDisabledColor": "var(--neutral-gray-80)",
  "sliderAquaTrackFillColor": "var(--background-brand-aqua-primary)",
  "sliderAquaTrackEmptyColor": "var(--background-neutral-quinary)",
  "sliderAquaTrackDisabledColor": "var(--background-neutral-disabled)",
  "heading-xxl": "slider-module__heading-xxl___P2ZhW",
  "heading-xl": "slider-module__heading-xl___1K2Ow",
  "heading-lg": "slider-module__heading-lg___PlP-i",
  "heading-md": "slider-module__heading-md___RvXRX",
  "heading-sm": "slider-module__heading-sm___zCqYT",
  "heading-xs": "slider-module__heading-xs___1Oea4",
  "body-one": "slider-module__body-one___s-QcM",
  "body-two": "slider-module__body-two___Bidf9",
  "body-three": "slider-module__body-three___p8Yps",
  "body-four": "slider-module__body-four___dWgJd",
  "overline-one": "slider-module__overline-one___yVheq",
  "overline-two": "slider-module__overline-two___CS0av",
  "overline-three": "slider-module__overline-three___HmcH9",
  "strong": "slider-module__strong___jClcT",
  "extra-strong": "slider-module__extra-strong___PF9Lq",
  "em": "slider-module__em___7uMkp",
  "figcaption": "slider-module__figcaption___UK6IN",
  "slider": "slider-module__slider___QI9BN",
  "sliderLabelSection": "slider-module__sliderLabelSection___SX9cx",
  "sliderLabel": "slider-module__sliderLabel___Eib1d",
  "sliderMainContainer": "slider-module__sliderMainContainer___9fbxR",
  "sliderWrapper": "slider-module__sliderWrapper___QOAcG",
  "centerMark": "slider-module__centerMark___m6cOE",
  "slider-black": "slider-module__slider-black___NY5BD",
  "isDisabled": "slider-module__isDisabled___U67h2",
  "slider-brand": "slider-module__slider-brand___vj2gI",
  "slider-white": "slider-module__slider-white___sSIk-",
  "slider-aqua": "slider-module__slider-aqua___zM6pJ"
};

// src/slider/Slider.tsx
var import_jsx_runtime4 = require("react/jsx-runtime");
var defaultSliderButtonProps = {
  type: "tertiary",
  color: "black",
  isIconOnly: true,
  size: "xs"
};
var sliderTrackColorsMap = {
  black: {
    fill: slider_module_default.sliderBlackTrackFillColor,
    empty: slider_module_default.sliderBlackTrackEmptyColor,
    disabled: slider_module_default.sliderBlackTrackDisabledColor
  },
  brand: {
    fill: slider_module_default.sliderBrandTrackFillColor,
    empty: slider_module_default.sliderBrandTrackEmptyColor,
    disabled: slider_module_default.sliderBrandTrackDisabledColor
  },
  white: {
    fill: slider_module_default.sliderWhiteTrackFillColor,
    empty: slider_module_default.sliderWhiteTrackEmptyColor,
    disabled: slider_module_default.sliderWhiteTrackDisabledColor
  },
  aqua: {
    fill: slider_module_default.sliderAquaTrackFillColor,
    empty: slider_module_default.sliderAquaTrackEmptyColor,
    disabled: slider_module_default.sliderAquaTrackDisabledColor
  }
};
var Slider = ({
  label,
  onChange,
  name,
  value,
  disabled = false,
  color = "black",
  isCentered = false,
  isPercentMode = false,
  hideValue = false,
  step = 1,
  // TODO: Uncomment when working on adding steps support
  // steps,
  isRtl = document.documentElement.dir === "rtl",
  minValue = 0,
  maxValue = 100,
  leftButtonProps,
  rightButtonProps,
  className,
  ...HTMLInputAttributes
}) => {
  const labelId = `${name}-label`;
  const fillColor = sliderTrackColorsMap[color][disabled ? "disabled" : "fill"];
  const emptyColor = sliderTrackColorsMap[color][disabled ? "disabled" : "empty"];
  const gradientDirection = isRtl ? "left" : "right";
  const [backgroundStyle, setBackgroundStyle] = (0, import_react3.useState)("");
  const minSliderValue = isPercentMode && minValue === void 0 ? 0 : minValue;
  const maxSliderValue = isPercentMode && minValue === void 0 ? 100 : maxValue;
  const calculateFillPercent = (0, import_react3.useCallback)(
    (value2) => {
      const center = (Number(minSliderValue) + Number(maxSliderValue)) / 2;
      if (isCentered) {
        if (value2 >= center) {
          return {
            fillPercent: (value2 - center) / (Number(maxSliderValue) - center) * 50 + 50,
            leftFill: false
            // No left fill, fill right side only
          };
        } else {
          return {
            fillPercent: 50 - (center - value2) / (center - Number(minSliderValue)) * 50,
            leftFill: true
            // Left fill from center
          };
        }
      } else {
        return {
          fillPercent: 100 * (value2 - Number(minSliderValue)) / (Number(maxSliderValue) - Number(minSliderValue)),
          leftFill: false
        };
      }
    },
    [isCentered, minSliderValue, maxSliderValue]
  );
  const handleChange = (event) => {
    const snappedValue = Number(event.target.value);
    onChange({ ...event, target: { ...event.target, value: `${snappedValue}` } });
  };
  const handleControlButtonClick = (0, import_react3.useCallback)(
    (operation) => {
      const newValue = operation === "subtract" ? +value - step : +value + step;
      if (newValue >= minValue && newValue <= maxValue) {
        onChange({
          target: { value: `${newValue}` }
        });
      }
    },
    [maxValue, minValue, onChange, step, value]
  );
  (0, import_react3.useEffect)(() => {
    const { fillPercent, leftFill } = calculateFillPercent(Number(value));
    if (isCentered) {
      setBackgroundStyle(
        leftFill ? `linear-gradient(to ${gradientDirection}, ${emptyColor} ${fillPercent}%, ${fillColor} ${fillPercent}%, ${fillColor} 50%, ${emptyColor} 50%)` : `linear-gradient(to ${gradientDirection}, ${emptyColor} 50%, ${fillColor} 50%, ${fillColor} ${fillPercent}%, ${emptyColor} ${fillPercent}%)`
      );
    } else {
      setBackgroundStyle(
        `linear-gradient(to ${gradientDirection}, ${fillColor} ${fillPercent}%, ${emptyColor} ${fillPercent}%)`
      );
    }
  }, [
    value,
    fillColor,
    emptyColor,
    minSliderValue,
    maxSliderValue,
    calculateFillPercent,
    isCentered,
    gradientDirection,
    isRtl
  ]);
  const showLabelSection = label || !hideValue;
  const buttonColor = color === "white" || color === "aqua" ? "white" : "black";
  return /* @__PURE__ */ (0, import_jsx_runtime4.jsxs)(
    "div",
    {
      className: (0, import_classnames3.default)(
        slider_module_default.slider,
        slider_module_default[`slider-${color}`],
        disabled && slider_module_default.isDisabled,
        className
      ),
      children: [
        showLabelSection && /* @__PURE__ */ (0, import_jsx_runtime4.jsxs)("div", { className: slider_module_default.sliderLabelSection, children: [
          label && /* @__PURE__ */ (0, import_jsx_runtime4.jsx)("label", { id: labelId, className: slider_module_default.sliderLabel, children: label }),
          !hideValue && /* @__PURE__ */ (0, import_jsx_runtime4.jsx)("span", { children: isPercentMode ? `${value}%` : value })
        ] }),
        /* @__PURE__ */ (0, import_jsx_runtime4.jsxs)("div", { className: slider_module_default.sliderMainContainer, children: [
          leftButtonProps && /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
            Button_default,
            {
              ...defaultSliderButtonProps,
              color: buttonColor,
              onClick: () => handleControlButtonClick("subtract"),
              disabled,
              ...leftButtonProps
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime4.jsx)("div", { className: slider_module_default.sliderWrapper, children: /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
            "input",
            {
              type: "range",
              name,
              min: minSliderValue,
              max: maxSliderValue,
              value,
              step,
              disabled,
              onChange: handleChange,
              "aria-labelledby": labelId,
              style: { background: backgroundStyle },
              ...HTMLInputAttributes
            }
          ) }),
          rightButtonProps && /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
            Button_default,
            {
              ...defaultSliderButtonProps,
              color: buttonColor,
              onClick: () => handleControlButtonClick("add"),
              disabled,
              ...rightButtonProps
            }
          )
        ] })
      ]
    }
  );
};
var Slider_default = Slider;
//# sourceMappingURL=index.js.map